import { useSelector } from 'react-redux';

import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import MemberForm from './MemberForm';

const MemberPanel = props => {
  const {
    member,
    action,
    onClose,
    account,
    onDelete
  } = props;

  // if we're creating a member then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  let cards = [
    {
      label: 'Delete Member',
      message: 'Deleting a member will remove them from the account. They will no longer be able to log into the company portal.',
      actions: [
        { label: 'Delete Member', callback: onDelete }
      ]
    }
  ]

  return <ResourceModalPanel cards={cards} />;
}

const MemberModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    member,
    onDestroy
  } = props;

  const account = useSelector(state => state.portalReducer.account);

  const action = member ? 'update' : 'create';

  let title, subTitle = null;
  if (member) {
    title = member.name || 'No name';

    let contactInfo = [];
    if (member.email) {
      contactInfo.push(member.email);
    }
    if (member.phone) {
      contactInfo.push(member.phone);
    }

    subTitle = contactInfo.join(', ');

  } else {
    title = 'New Member';
  }

  const onSubmit = params => onFormSubmit(action, params);
  const onDelete = () => onDestroy(member.id);

  return (
    <div>
      <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
        <MemberPanel {...{ member, action, onClose, account, onDelete }} />
        <MemberForm {...{ member, action, onClose, account, onSubmit }} />
      </ResourceModal>
    </div>
  );
}

export default MemberModal;
